export default __webpack_public_path__ + "static/media/logo2.svg.a362efb0.svg";